import { useQueryApi } from 'utils/api'

import type { TMilCommonErrorResponse } from 'types/microlearning'

export function useGetDeviceId() {
  return useQueryApi<{ deviceId: string }, TMilCommonErrorResponse>(
    `/device-id`,
    {
      queryConfig: {
        useErrorBoundary: false,
      },
      axiosConfig: {
        url: `/pelatihan-mandiri/api/device-id`,
      },
    }
  )
}
